<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <hm-logo/>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Hostmatic"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Welcome to Hostmatic
          </b-card-title>
          <b-card-text class="mb-2">
            Please sign-in to your account
          </b-card-text>

          <b-form
            class="auth-login-form mt-2"
            @submit.prevent
          >
            <!-- email -->
            <b-form-group
              label="Username or Email"
              label-for="login-email"
            >
              <b-form-input
                id="login-email"
                v-model="$v.user.$model"
                :state="!$v.user.$error"
                name="login-email"
                placeholder="john@example.com"
              />
            </b-form-group>

            <!-- forgot password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="login-password">Password</label>
                <b-link :to="{name:'auth-forgot-password'}">
                  <small>Forgot Password?</small>
                </b-link>
              </div>
              <b-input-group
                class="input-group-merge"
                :class="{'is-invalid': $v.password.$error}"
              >
                <b-form-input
                  id="login-password"
                  v-model="$v.password.$model"
                  :state="!$v.password.$error"
                  class="form-control-merge"
                  :type="passwordFieldType"
                  name="login-password"
                  placeholder="············"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="passwordToggleIcon"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="status"
                name="checkbox-1"
              >
                Remember Me
              </b-form-checkbox>
            </b-form-group>

            <!-- submit buttons -->
            <b-button
              type="submit"
              variant="primary"
              block
              @click="login"
            >
              Sign in
            </b-button>
          </b-form>
          <b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link :to="{name:'auth-register'}">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import hmLogo from '@core/layouts/components/Logo.vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { hmError, hmSuccess } from '@/libs/toastification'
import api from '@/libs/axios'

export default {
  components: {
    hmLogo
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      user: '',
      sideImg: require('@/assets/images/pages/login/login.jpg')
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login/login.jpg')
        return this.sideImg
      }
      return this.sideImg
    }
  },
  validations: {
    user: { required },
    password: { required }
  },
  methods: {
    login() {
      this.$v.$touch()
      if (this.$v.$invalid) return
      api.post('/api/auth/login', { user: this.user, password: this.password }).then(r => {
        if (r.data.code === 'Error') return hmError('Invalid user or password')
        if (r.data.code !== 'Ok') {
          return hmError('Error')
        }
        sessionStorage.setItem('hm_userData', JSON.stringify(r.data.user))
        this.$router.replace(getHomeRouteForLoggedInUser(r.data.user.role))
          .then(() => {
            hmSuccess(`You have successfully logged in as ${r.data.user.user.login}. Now you can start to explore!`)
          })
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
